import { createAction } from 'redux-actions';

export const clearPosSearchItems = createAction('CLEAR_POS_SEARCH_ITEMS');
